import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import Logo from './Logo';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const handleWhatsApp = () => {
    window.open(companyInfo.whatsappLink, '_blank');
  };

  const handleCall = () => {
    window.location.href = companyInfo.callLink;
  };

  return (
    <footer className="bg-[#0a0e12] text-gray-300 border-t border-gray-800">
      <div className="container mx-auto px-4 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <Logo className="mb-4" />
            <p className="text-[17px] mb-4 text-gray-400">
              AMFI Registered Mutual Fund Distributor
            </p>
            <p className="text-sm text-gray-500 mb-2">ARN: {companyInfo.arn}</p>
            <p className="text-[17px] text-gray-400">{companyInfo.tagline}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-[17px]">
              <li>
                <Link to="/" className="hover:text-[#F59E0B] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-[#F59E0B] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-[#F59E0B] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/calculators" className="hover:text-[#F59E0B] transition-colors">
                  Calculators
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-[#F59E0B] transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2.5 text-[17px] text-gray-400">
              <li>Mutual Funds</li>
              <li>Life Insurance</li>
              <li>Health Insurance</li>
              <li>Financial Planning</li>
              <li>Retirement Planning</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-4">Contact Us</h4>
            <ul className="space-y-3 text-[17px]">
              <li className="flex items-start">
                <Mail className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0 text-[#F59E0B]" />
                <div className="flex flex-col">
                  <a
                    href={`mailto:${companyInfo.email}`}
                    className="hover:text-[#F59E0B] transition-colors break-all"
                  >
                    {companyInfo.email}
                  </a>
                  <a
                    href={`mailto:${companyInfo.email2}`}
                    className="hover:text-[#F59E0B] transition-colors break-all mt-1"
                  >
                    {companyInfo.email2}
                  </a>
                </div>
              </li>
              <li className="flex items-start">
                <Phone className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0 text-[#F59E0B]" />
                <div className="flex flex-col space-y-1">
                  <button
                    onClick={handleWhatsApp}
                    className="hover:text-[#F59E0B] transition-colors text-left"
                  >
                    WhatsApp: {companyInfo.whatsapp}
                  </button>
                  <button
                    onClick={handleCall}
                    className="hover:text-[#F59E0B] transition-colors text-left"
                  >
                    Call: {companyInfo.callNumber}
                  </button>
                </div>
              </li>
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0 text-[#F59E0B]" />
                <span className="text-gray-400">{companyInfo.address}</span>
              </li>
            </ul>

            {/* Action Buttons */}
            <div className="mt-4 space-y-2">
              <Button
                onClick={handleCall}
                className="w-full bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] hover:from-[#D97706] hover:to-[#F59E0B] text-black font-semibold"
              >
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
              <Button
                onClick={handleWhatsApp}
                className="w-full bg-transparent border-2 border-[#F59E0B] text-[#F59E0B] hover:bg-[#F59E0B]/10 font-semibold"
              >
                <Phone className="w-4 h-4 mr-2" />
                WhatsApp Us
              </Button>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="border-t border-gray-800 pt-6 mb-6">
          <p className="text-sm text-gray-500 text-center max-w-4xl mx-auto leading-relaxed">
            <strong className="text-white">Disclaimer:</strong> {companyInfo.disclaimer}
          </p>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <p className="mb-4 md:mb-0 text-gray-500">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <div className="flex space-x-6">
              <Link to="/privacy-policy" className="hover:text-[#F59E0B] transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-conditions" className="hover:text-[#F59E0B] transition-colors">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
